"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createIsIllegalWord = void 0;
const createIsIllegalWord = (illegalWordRegex, isReservedWord) => property => illegalWordRegex.test(property) || isReservedWord(property);
exports.createIsIllegalWord = createIsIllegalWord;